export const MENUS = [
  {
    title: 'Home',
    link: '/',
    decription: 'Home Page',
    // children: [
    //   "Home 1",
    // ]
  },
  {
    title: 'Products',
    link: '/products',
    decription: 'Products',
    childrenKey: 'productTypes'
  },
  {
    title: 'Blog',
    link: '/blog',
    decription: 'Home Page'
  },
  {
    title: 'About',
    link: '/about',
    decription: 'Home Page'
  },
]